import React, { useState, useEffect, ChangeEvent } from 'react'
import { Box, Typography, Button, ListItem, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useDataProvider, useTranslate } from 'react-admin'
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import TextButton from '../CustomizedUIs/TextButton';
import { Device, FormUpdateProps, ResponseDevices } from '../types';
import TextField from '../CustomizedUIs/CustomTextFiled'


const useStyles = makeStyles(theme => ({

    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        '&:hover': {
            backgroundColor: '#a7cce7',
        }
    }
    , borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },

    large: {
        marginLeft: 16,
        border: '1px solid #ddd',
        borderRadius: 4,
        padding: 5,
        width: 150,
        height: 100,
        '&:hover': {
            boxShadow: '0 0 2px 1px rgba(0, 140, 186, 0.5)'
        }
    },
}));


const FormUpdate = ({ itemRow, roomID, onGoBack }: FormUpdateProps) => {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const [loading, setLoading] = useState<boolean>(false)
    const [openListDevice, setOpenListDevice] = useState<boolean>(false)
    const [textValue, setTextValue] = useState<string>('')

    const [device, setDevice] = useState<Partial<Device>>({});
    const [devices, setDevices] = useState<Array<Device>>([]);
    const [error, setError] = useState({
        clientID: { message: '' },
    })

    const onChangeListDevice = (value: Device) => {
        setDevice(value);
        setOpenListDevice(false);
    }

    const handleClickOpenListDevice = () => {
        setOpenListDevice(!openListDevice)
    }

    const onChangTextValue = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === '') {
            setError({
                ...error, clientID: { message: 'required' }
            })
        }
        else if (event.target.value.length > 32) {
            setError({
                ...error, clientID: { message: 'Maximum of 32 characters are allowed' }
            })
            return
        } else {
            setError({
                ...error, clientID: { message: '' }
            })
        }
        setTextValue(event.target.value)
    }

    const onCreate = () => {
        setLoading(true)
        dataProvider('CREATE', "external-device", {
            data: {
                macAddressBox: device.macAddressSecondary,
                deviceId: textValue
            }
        })
            .then(({ data }: any) => {
                setLoading(false);
                onGoBack()
            })
            .catch((error: any) => {
                console.error('Error external device:', error);
            })
    }

    const onEdit = () => {
        if (itemRow && Object.keys(itemRow).length > 0 && (textValue.length > 0 || Object.keys(device).length > 0)) {
            setLoading(true)
            dataProvider('UPDATE', "external-device", {
                id: itemRow.id,
                data: {
                    macAddressBox: Object.keys(device).length > 0 ? device.macAddressSecondary : itemRow.macAddressBox,
                    deviceId: textValue
                }
            }).then(({ data }: any) => {
                setLoading(false);
                onGoBack();
            }).catch((error: any) => {
                setLoading(false)
            })
        }
    }

    useEffect(() => {
        if (roomID || itemRow) {
            if (itemRow && Object.keys(itemRow).length > 0) {
                setTextValue(itemRow?.deviceId || "")
            }
            dataProvider('GET_LIST', "devicesbyroom", {
                filter: {
                    room: roomID
                },
                pagination: {},
                sort: {},
            }).then((response: ResponseDevices) => {
                const { data } = response;
                if (data && data.length > 0) {
                    setDevices(data);
                    if (data.filter(item => item.macAddressSecondary === itemRow?.macAddressBox).length > 0) {
                        setDevice(data.filter(item => item.macAddressSecondary === itemRow?.macAddressBox)[0])
                    }
                }
            }).catch((error: any) => {
            });
        }
    }, [roomID, itemRow]);

    return (
        <Box>
            <Box my={2}>
                <TextField
                    required
                    style={{ width: 500 }}
                    variant='filled'
                    label={translate('pos.externalDevice.clientID')}
                    value={textValue}
                    onChange={onChangTextValue}
                    endDom={undefined}
                    error={error && error.clientID.message.length > 0}
                    helperText={error.clientID.message}
                />
            </Box>
            <Box my={2}>
                <SelectBox
                    label={translate(`pos.externalDevice.listDevices`)}
                    value={
                        <Typography variant='body1'>
                            {
                                Object.keys(device).length === 0 ? "None" : device.name
                            }
                        </Typography>
                    }
                    open={openListDevice}
                    handleClick={handleClickOpenListDevice}
                    CreateBox={undefined}
                    disabled={undefined}
                    required={undefined}
                    header={undefined}
                    filter={undefined}
                    bgcolor={undefined}
                    maxHeight={undefined}
                >
                    {
                        devices.map((item, index) => (
                            <ListItem
                                key={index}
                                button
                                onClick={() => onChangeListDevice(item)}
                            >
                                <Typography>
                                    {
                                        item.name
                                    }
                                </Typography>
                            </ListItem>
                        ))
                    }
                </SelectBox>
            </Box>


            <Box my={2} display='flex' width='100%' justifyContent='flex-end' alignItems='flex-end'>
                <TextButton style={{ marginRight: '30px' }} onClick={onGoBack} />

                <Button disabled={error.clientID.message.length > 0 || Object.keys(device).length === 0} style={{ padding: 8 }} variant='contained' color='primary' onClick={itemRow ? onEdit : onCreate}>
                    {loading ? (
                        <CircularProgress
                            size={15}
                            thickness={2}
                            color='inherit'
                        />
                    ) :
                        itemRow ? translate(`pos.common.save`) : translate(`pos.common.create`)
                    }
                </Button>
            </Box>
        </Box >
    )


}
export default FormUpdate